import React, { useRef, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import AxiosClient from '../../assets/AxiosClient';
import defult from './defult.jpg';
import { useStateContext } from '../../Contexts/ContextProvider';
import ConferenceDropdown from '../../Forms/ConferenceDropdown';
const AddNews = () => {
  const {SetNotification}= useStateContext() ; 
  const titleRef = useRef(null);
  const descriptionRef = useRef(null);
  const ContentRef = useRef(null);
  const [image_, setImage] = useState(defult);
  const [Active, setActice] = useState(1);
  const [penn, setPenn] = useState(0);
  const [imagePreviewUrl, setImagePreviewUrl] = useState();
  const [lang,setLang]= useState("EN") ; 
  const [sending , setIsSending] = useState(false) ; 
  const [conferenceId, setConferenceId] = useState(null);

  const handleImageChange = (e) => {
    const selectedImage = e.target.files[0];
    setImage(selectedImage);

    const reader = new FileReader();

    // Set up the onload callback function
    reader.onload = (event) => {
      // Set the image preview URL
      setImagePreviewUrl(event.target.result);
    };

    // Read the image file as a data URL
    reader.readAsDataURL(selectedImage);
  };

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSending(true) ; 
    const payload = {
      title: titleRef.current.value,
      description: descriptionRef.current.value,
      content: ContentRef.current.value,
      image: image_,
      conference_id: conferenceId,

      penn: penn,
      active: Active,
      lang : lang 
    };
console.log(payload);
await AxiosClient.post('/news', payload,  {headers: {
  'Content-Type': 'multipart/form-data',
}}).then((response) =>{
  if (response.status ==201) 
  {
    SetNotification('News added successfully' , "success");
    navigate(-1);
  }
 
  
}).catch((error)=>{
  if (error.response && error.response.data && error.response.data.message) {
    const errorMessage = error.response.data.message;
    SetNotification(errorMessage, 'danger');
  } else {
    SetNotification('An error occurred while Add news.', 'danger');
  }


});
setIsSending(false) ; 
}

  return (
    <div className="m-4"> 
    <ConferenceDropdown setConferenceId={setConferenceId} conferenceId={conferenceId}/>
       <h5>
         Language
        </h5>
        <> 
        <button className={`btn btn-${lang=='AR' ? 'info': 'dark' } m-2`} onClick={()=>setLang("AR")}>
          arabic
        </button>

        </>
      
      <>
      <button className={`btn btn-${lang=='EN' ? 'info': 'dark' } m-2`} onClick={()=>setLang("EN")}>
          English
        </button>

      </>
       {lang == 'AR' ?<img src="https://flagsapi.com/IQ/shiny/64.png"/> : <img src="https://flagsapi.com/GB/shiny/64.png"/> } 
      
      <form  className="form-group" dir={lang=='AR' ? "rtl" : 'ltr'} > 
         <h5>{lang == 'EN' ? 'Title' :"عنوان الخبر " }</h5>
        <div className="input-group input-group-outline mb-3">
          <input type="text" className="form-control" placeholder="Enter title" ref={titleRef}  />
        </div>
      
        <h5>{lang == 'EN' ? 'Description' :"وصف الخبر " }</h5>
        <div className="input-group input-group-outline mb-3">
          <textarea className="form-control" placeholder="Enter description" rows={5} ref={descriptionRef} />
        </div>

        <h5>{lang == 'EN' ? 'Image' :"صورة الخبر " }</h5>
        <div className="w-full flex flex-wrap items-center">
          <label htmlFor="imageUpload" className="w-full block mb-2 font-medium text-gray-700 m-2">
            Article Image:
          </label>
          <input
            type="file"
            id="imageUpload"
            accept="image/*"
            onChange={handleImageChange}
            className="py-2 m-2 px-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
        <img
          src={imagePreviewUrl ? imagePreviewUrl : defult}
          alt="Uploaded"
          style={{ maxWidth: '250px', maxHeight: '25%' }}
          className="w-full object-contain mb-w-100 text-center"
        />

        <hr className="border-gray-300 my-4" />

        <h5>{lang == 'EN' ? 'Contant' :"محتوى الخبر " }</h5>
        <div className="input-group input-group-outline mb-3">
          <textarea className="form-control" placeholder="Content" rows={15} ref={ContentRef} />
        </div>
{sending ? <h1>sending ... </h1> :  <button onClick={handleSubmit} className="btn btn-primary">
          Submit
        </button>}
       
      </form>
    </div>
  );
};

export default AddNews;